import { render } from "./ageSelect.vue?vue&type=template&id=9bd2230c&scoped=true"
import script from "./ageSelect.vue?vue&type=script&lang=js"
export * from "./ageSelect.vue?vue&type=script&lang=js"

import "./ageSelect.vue?vue&type=style&index=0&id=9bd2230c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd2230c"]])

export default __exports__